import { Injectable } from '@angular/core';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { VehicleBrandService } from '../vehicle-brand/vehicle-brand.service';
import { VehicleBrand } from '../vehicle-brand/vehicle-brand';

@Injectable({ providedIn: 'root'})
export class VehicleBrandResolver implements Resolve<Observable<VehicleBrand[]>>{

    constructor(private service: VehicleBrandService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<VehicleBrand[]> {
        return this.service.findAll();
    }
}